import React from "react";
import { GlobalSearchResult } from "../types";
import { SearchItem } from "./SearchItem";

interface SearchResultItemProps {
  result: GlobalSearchResult;
  isSelected: boolean;
  onClick: () => void;
  onOpenInNewTab: () => void;
  isOtherMatch?: boolean;
}

export const SearchResultItem = React.forwardRef<
  HTMLDivElement,
  SearchResultItemProps
>(
  (
    { result, isSelected, onClick, onOpenInNewTab, isOtherMatch = false },
    ref
  ) => {
    return (
      <SearchItem
        ref={ref}
        item={result}
        isSelected={isSelected}
        onClick={onClick}
        onOpenInNewTab={onOpenInNewTab}
        variant="search-result"
        isOtherMatch={isOtherMatch}
        data-test={`global-search-result-item-${result.id}`}
      />
    );
  }
);

SearchResultItem.displayName = "SearchResultItem";
